import React, { useEffect, useState } from "react";
import styles from "../../assets/styles/salesSlotBooking.module.css";
import { SlDrawer } from "@shoelace-style/shoelace/dist/react";
import EditIconsSvg from "../../assets/images/edit-icon.svg";
import DeleteIconSvg from "../../assets/images/delete_icon.svg";
import viewIconSvg from "../../assets/images/view_icon.svg";
import logsIconSvg from "../../assets/images/hamburger.svg";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import API from "../../services/api";
import {
  getGenerateUrl,
  langoptions_preview,
  roles,
} from "../../utils/constants";
import BookSlot from "./BookSlot";
import SlotVIew from "./SlotVIew";
import { formatDateWithTime } from "../../utils/dateFormat";
import SlotHistory from "./SlotHistory";

function UserActivity(props) {
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [moreLoader, setMoreLoader] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  const [bookSlotModalOpen, setBookSlotModalOpen] = useState(false);
  const [editItem, setEditItem] = useState(null);
  const [slotView_id, setSlotView_id] = useState(null);
  const [slotLog_id, setSlotLog_id] = useState(null);
  const [page, setPage] = useState(0);
  const [optionIndex, setOptionIndex] = useState(-1);

  const fetchRecentyActivity = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/slotbooking/get-recent-activity",
        method: "POST",
        responseType: "json",
        data: { page: 0 },
      });
      if (res.code === 200) {
        setData(res.data);
        setInitialRender(false);
        setPage(0);
      }
    } catch (error) {
      console.error("Error fetching brands:", error);
    } finally {
      setLoader(false);
    }
  };
  const fetchMoreRecentyActivity = async () => {
    try {
      setMoreLoader(true);
      let res = await API({
        url: "/slotbooking/get-recent-activity",
        method: "POST",
        responseType: "json",
        data: { page },
      });
      if (res.code === 200) {
        setData([...data, ...res.data]);
      }
      setMoreLoader(false);
    } catch (error) {
      console.error("Error fetching brands:", error);
    } finally {
    }
  };

  useEffect(() => {
    fetchRecentyActivity();
  }, []);
  useEffect(() => {
    if (
      props.showActivity &&
      !initialRender &&
      !slotView_id &&
      !slotLog_id &&
      !bookSlotModalOpen
    ) {
      setOptionIndex(-1);
      fetchRecentyActivity();
    }
  }, [props.showActivity, slotView_id, slotLog_id, bookSlotModalOpen]);
  useEffect(() => {
    if (page !== 0) fetchMoreRecentyActivity();
  }, [page]);
  const handleViewAction = async (slotItem) => {
    setSlotView_id(slotItem.slot_id);
  };
  const handleLogAction = async (slotItem) => {
    setSlotLog_id(slotItem.slot_id);
  };

  const handleEditAction = async (slotItem) => {
    try {
      let apiResult = await API({
        url: "/slotbooking/slot_details",
        method: "POST",
        responseType: "json",
        data: { slot_id: slotItem.slot_id },
      });
      if (apiResult.code === 200) {
        setEditItem({
          ...apiResult.data,
          action: "edit",
        });
        setBookSlotModalOpen(true);
        setInitialRender(false);
      }
    } catch (error) {
      console.error("Error @ handleEditAction", error);
    }
  };


  return (
    // <SlDrawer
    //   open={props.showActivity ? true : false}
    //   onSlAfterHide={() => {
    //     props.setShowActivity(false);
    //   }}
    //   label={"Your Recent Activity"}
    //   style={{ "--size": "650px", "--background-color": "#1D1D1D" }}
    //   className={styles["sldrawer-container"]}
    // >
    <div
      className={`${styles["activity-panel"]} ${
        props.hideActivity ? styles["hideActivity"] : ""
      }`}
      id={styles["activityPanel"]}
    >
      <div className={styles["title-head"]}>
        <h2>
          <span>Your Recent Activity</span>
        </h2>
        <span
          class={styles["close"]}
          onClick={() => {
            props.setShowActivity(false);
          }}
        >
          &times;
        </span>
      </div>
      <div className={styles["activity-cards"]}>
        {data?.length && !loader ? (
          data.map((slotItem, index) => {
            let {
              slot,
              actualTarget,
              state_Objs,
              district_Objs,
              mandal_Objs,
              constituency_Objs,
              village_Objs,
              slot_name,
              sales_name,
              position,
              editTime,
              internal_details
            } = slotItem;
            if(!slot){
              slot = internal_details[0].slot
            }
            if(!position){
              position = internal_details[0].position
            }
            return (
              <div
                className={`${styles["slot-details"]} ${
                  optionIndex === index ? styles["show"] : ""
                } ${slotItem.order_id ? styles['picked'] : ''}`}
                onClick={() => {
                  setOptionIndex(index);
                }}
              >
                <div className={styles["slot-row"]}>
                  {slotItem?.logo_url || getGenerateUrl(slotItem?.brand_name || "") ? (
                    <img
                      src={
                        slotItem?.logo_url ||
                        getGenerateUrl(slotItem?.brand_name || "")
                      }
                      className={styles["brand-logo"]}
                      // title={slotItem.brand_name}
                    />
                  ) : null}
                  <h2 className={styles["position-placement"]}>
                    <span>{position}</span>
                  </h2>
                  <h2 className={styles["slot-placement"]}>
                    <span>
                      {slot === 0
                        ? "A"
                        : slot === 1
                        ? "B"
                        : slot === 2
                        ? "C"
                        : "-"}
                    </span>
                  </h2>
                  <p>{slot_name}</p>
                  <div className={styles["clear-all-full"]}>
                    <h6
                      className={`ml-auto ${styles["maxwidth"]}`}
                      title={slotItem.brand_name}
                    >
                      {slotItem.brand_name}
                    </h6>
                    <h6
                      className={`ml-1 ${styles["maxwidth"]}`}
                      title={sales_name}
                    >
                      {sales_name}
                    </h6>
                  </div>
                </div>
                <div className={styles["slot-row"]}>
                  <ul className={styles["locations-list"]}>
                    {actualTarget?.lang_ids && actualTarget?.lang_ids?.length > 0 ? actualTarget?.lang_ids.map((lang_id) => (
                      <li
                        className={styles["lang"]}
                      >{`${langoptions_preview[lang_id]}`}</li>
                    )) : null}

                    {actualTarget?.state_ids?.length ? state_Objs
                      .filter((st) =>
                        actualTarget.state_ids.includes(st.state_id)
                      )
                      .map((item) => (
                        <li
                          className={styles["state"]}
                        >{`${item.state_name}`}</li>
                      )) : null}

                    {actualTarget?.district_ids?.length ? district_Objs
                      .filter((di) =>
                        actualTarget.district_ids.includes(di.dist_id)
                      )
                      .map((item) => (
                        <li
                          className={styles["dist"]}
                        >{`${item.dist_name}`}</li>
                      )) : null}

                    { constituency_Objs?.length ? constituency_Objs?.map((item) => (
                      <li
                        className={styles["consti"]}
                      >{`${item.const_name}`}</li>
                    )) : null}
                  </ul>
                </div>
                <div className={styles["options"]}>
                  {localStorage.getItem("role") === roles.salesperson &&
                  slotItem.mine &&
                  slotItem.status === 4 ? (
                    <button
                      id="edit"
                      className={styles["editSlot"]}
                      onClick={() => {
                        handleEditAction(slotItem);
                      }}
                    >
                      <img src={EditIconsSvg} alt="" />
                      <span>Edit</span>
                    </button>
                  ) : null}
                  <button
                    id="view"
                    onClick={() => {
                      handleViewAction(slotItem);
                    }}
                  >
                    <img src={viewIconSvg} alt="" />
                    <span>View</span>
                  </button>
                  <button
                    id="logs"
                    onClick={() => {
                      handleLogAction(slotItem);
                    }}
                  >
                    <img src={logsIconSvg} alt="" />
                    <span>Logs</span>
                  </button>
                </div>
                <span className={styles["editTime"]}>
                  {formatDateWithTime(editTime)}
                </span>
                <span
                  className={`${styles["status"]} ${
                    slotItem.status === 1
                      ? styles["pending"]
                      : slotItem.status === 2
                      ? styles["finance_pending"]
                      : slotItem.status === 3
                      ? styles["approved"]
                      : slotItem.status === 4
                      ? styles["rejected"]
                      : styles["deleted"]
                  }`}
                >
                  {slotItem.status === 1
                    ? "pending"
                    : slotItem.status === 2
                    ? "finance_pending"
                    : slotItem.status === 3
                    ? "approved"
                    : slotItem.status === 4
                    ? "rejected"
                    : "deleted"}
                </span>
              </div>
            );
          })
        ) : !data?.length && !loader ? (
          <div
            className="w-full h-full d-flex justify-center"
            style={{ color: "#fff" }}
          >
            <NoDataFound colspan="15" />
          </div>
        ) : (
          <div className="w-full h-full d-flex justify-center">
            <TableLoader colspan="15" />
          </div>
        )}
        {moreLoader ? (
          <div className="w-full h-full d-flex justify-center">
            <TableLoader />
          </div>
        ) : (
          <button
            onClick={() => {
              setPage(page + 1);
            }}
            className={styles["loadmore"]}
          >
            Load More
          </button>
        )}
      </div>
      {bookSlotModalOpen && (
        <BookSlot
          show={bookSlotModalOpen}
          setShow={setBookSlotModalOpen}
          editItem={editItem}
        />
      )}
     
      {slotView_id ? (
        <SlotVIew slot_id={slotView_id} setSlot_id={setSlotView_id} />
      ) : null}
      {slotLog_id ? (
        <SlotHistory slotLog_id={slotLog_id} setSlotLog_id={setSlotLog_id} />
      ) : null}
    </div>
    // </SlDrawer>
  );
}

export default UserActivity;
